import React from 'react';

interface TaskSortProps {
    fill?: string;
}

export const TaskSearch = ({ fill = '#818998' }: TaskSortProps) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_4147_1847)">
                <path
                    d="M15.9678 15.0273L11.7987 10.8582C12.8816 9.53367 13.4141 7.84359 13.2859 6.13751C13.1577 4.43143 12.3787 2.83989 11.11 1.69208C9.84125 0.544267 8.17989 -0.0719896 6.46953 -0.0292254C4.75918 0.0135388 3.1307 0.712052 1.92092 1.92183C0.711137 3.13161 0.0126232 4.7601 -0.0301409 6.47045C-0.0729051 8.1808 0.543352 9.84216 1.69116 11.1109C2.83897 12.3796 4.43051 13.1586 6.13659 13.2868C7.84267 13.415 9.53275 12.8826 10.8573 11.7996L15.0264 15.9687L15.9678 15.0273ZM6.64687 11.974C5.59344 11.974 4.56367 11.6616 3.68778 11.0764C2.81188 10.4911 2.12921 9.65929 1.72608 8.68605C1.32295 7.7128 1.21747 6.64188 1.42298 5.60869C1.6285 4.5755 2.13577 3.62646 2.88066 2.88157C3.62554 2.13669 4.57459 1.62941 5.60778 1.4239C6.64096 1.21838 7.71189 1.32386 8.68513 1.72699C9.65837 2.13012 10.4902 2.8128 11.0755 3.68869C11.6607 4.56459 11.9731 5.59436 11.9731 6.64779C11.9715 8.0599 11.4099 9.41373 10.4113 10.4122C9.41281 11.4108 8.05899 11.9724 6.64687 11.974Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_4147_1847">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
